import React from 'react';

interface TestFlightBulkActionsProps {
  selectedCount: number;
  onSelectAllVisible: () => void;
  onSelectByStatus: (status: string) => void;
  onClearSelection: () => void;
  onExportSelected: () => void;
}

const TestFlightBulkActions: React.FC<TestFlightBulkActionsProps> = ({
  selectedCount,
  onSelectAllVisible,
  onSelectByStatus,
  onClearSelection,
  onExportSelected
}) => {
  return (
    <div className="bulk-selection-controls">
      <div className="bulk-actions">
        <span className="selected-count">
          {selectedCount} selected
        </span>
        
        <button 
          className="btn btn-secondary btn-sm" 
          onClick={onSelectAllVisible}
        >
          <span>☑️</span>
          Select All Visible
        </button>
        
        <button 
          className="btn btn-secondary btn-sm" 
          onClick={() => onSelectByStatus('INSTALLED')}
        >
          <span>✅</span>
          Select Installed
        </button>
        
        <button 
          className="btn btn-secondary btn-sm" 
          onClick={() => onSelectByStatus('INVITED')}
        >
          <span>📧</span>
          Select Invited
        </button>
        
        <button 
          className="btn btn-secondary btn-sm" 
          onClick={() => onSelectByStatus('NO_RESPONSE')}
        >
          <span>⏰</span>
          Select No Response
        </button>
        
        {selectedCount > 0 && (
          <button 
            className="btn btn-secondary btn-sm" 
            onClick={onClearSelection}
          >
            <span>❌</span>
            Clear Selection
          </button>
        )}
        
        <button 
          className={`btn btn-sm ${selectedCount > 0 ? 'btn-primary' : 'btn-secondary'}`}
          onClick={onExportSelected}
          disabled={selectedCount === 0}
        >
          <span>📥</span>
          Export Selected CSV
        </button>
      </div>
    </div>
  );
};

export default TestFlightBulkActions;
